/* Alpha Fortis draft cart. Shopify is the sole authority for prices/discounts. */
(() => {
  "use strict";
  const host = document.getElementById("af-cart-root");
  if (!host || window.AlphaFortisCart) return;
  let cfg;
  try { cfg = JSON.parse(host.querySelector("[data-af-config]").textContent); } catch (_) { return; }
  if (!Array.isArray(cfg.products)) return;
  const $ = s => host.querySelector(s);
  const esc = value => String(value ?? "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const colourKey = value => String(value || "").trim().toLowerCase().replace(/[^a-z0-9]/g, "");
  const path = window.Shopify?.routes?.root || "/";
  const baseFetch = window.fetch.bind(window);
  const drawer = $(".af-drawer");
  const backdrop = $(".af-backdrop");
  const storageKey = "af-custom-cart-deadline-v1";
  let cart = null, opened = false, busy = false, lastFocus = null, deadline = null;
  let refreshGeneration = 0, refreshTimer = null, productsUpdated = 0, previousOverflow = "";
  let productsPromise = null;
  const inertElements = new Map();
  try { const saved = Number(sessionStorage.getItem(storageKey)); if (saved > 0) deadline = saved; } catch (_) {}
  const money = cents => new Intl.NumberFormat(cart?.currency === "AUD" ? "en-AU" : (document.documentElement.lang || "en-AU"), {
    style: "currency", currency: cart?.currency || window.Shopify?.currency?.active || "AUD"
  }).format(cents / 100);
  const icon = name => {
    const paths = {
      truck: '<path d="M2 5h12v12H2zM14 9h4l4 5v3h-8"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>',
      tag: '<path d="M3 3h8l10 10-8 8L3 11z"/><circle cx="7.5" cy="7.5" r="1"/>',
      trash: '<path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7"/>',
      clock: '<circle cx="12" cy="12" r="9"/><path d="M12 6v6l4 2"/>'
    };
    return `<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">${paths[name]}</svg>`;
  };
  $(".af-shipping .af-mark").innerHTML = icon("truck");
  $(".af-deal .af-mark").innerHTML = icon("tag");
  const timerIcon = $(".af-timer>span");
  if (timerIcon) { timerIcon.innerHTML = icon("clock"); timerIcon.style.cssText = "width:15px;height:15px;display:block"; }

  function announce(text) { $("[data-af-announcer]").textContent = text; }
  function error(text = "") {
    $("[data-af-error]").hidden = !text;
    $("[data-af-error]").textContent = text;
  }
  function tick() {
    const clock = $("[data-af-clock]");
    if (!clock) return;
    const seconds = deadline === null ? (cfg.timerMinutes || 10) * 60 : Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
    clock.textContent = `${String(Math.floor(seconds / 60)).padStart(2, "0")}:${String(seconds % 60).padStart(2, "0")}`;
  }
  function lockBackground() {
    let ancestor = host;
    while (ancestor.parentElement && ancestor !== document.body) {
      for (const sibling of ancestor.parentElement.children) {
        if (sibling === ancestor || /^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName)) continue;
        inertElements.set(sibling, sibling.inert);
        sibling.inert = true;
      }
      ancestor = ancestor.parentElement;
    }
  }
  function close() {
    opened = false;
    drawer.hidden = true;
    backdrop.hidden = true;
    document.body.style.overflow = previousOverflow;
    for (const [element, wasInert] of inertElements) element.inert = wasInert;
    inertElements.clear();
    document.querySelector("cart-drawer")?.classList.remove("active");
    document.body.classList.remove("overflow-hidden");
    if (lastFocus?.isConnected) lastFocus.focus({ preventScroll: true });
  }
  function open() {
    if (!opened) {
      lastFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      opened = true;
      drawer.hidden = false;
      backdrop.hidden = false;
      lockBackground();
      document.body.style.overflow = "hidden";
      $("[data-af-close].af-icon").focus({ preventScroll: true });
      if (deadline === null) {
        deadline = Date.now() + (cfg.timerMinutes || 10) * 60000;
        try { sessionStorage.setItem(storageKey, String(deadline)); } catch (_) {}
      }
    }
    tick();
    refresh();
    refreshProducts();
  }
  async function refreshProducts() {
    if (Date.now() - productsUpdated < 60000 || productsPromise) return productsPromise;
    productsPromise = (async () => {
      try {
        const response = await baseFetch(`${path}?section_id=af-custom-cart`, { cache: "no-store", credentials: "same-origin" });
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), "text/html");
        const next = JSON.parse(doc.querySelector("[data-af-config]")?.textContent || "{}");
        if (Array.isArray(next.products)) { cfg.products = next.products; productsUpdated = Date.now(); renderRecommendations(); }
      } catch (_) { /* Initial Liquid snapshot remains available; add endpoint validates stock. */ }
      finally { productsPromise = null; }
    })();
    return productsPromise;
  }
  async function refresh() {
    const generation = ++refreshGeneration;
    try {
      const response = await baseFetch(`${path}cart.js`, { cache: "no-store", credentials: "same-origin" });
      if (!response.ok) throw new Error("Unable to load your cart. Please try again or open the cart page.");
      const next = await response.json();
      if (generation !== refreshGeneration) return;
      if (!Array.isArray(next.items) || !Number.isFinite(next.total_price)) throw new Error("Cart response unavailable.");
      cart = next;
      render();
    } catch (err) {
      if (generation === refreshGeneration) error(err.message);
    }
  }
  function scheduleRefresh(show = false) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => show ? open() : refresh(), 120);
  }
  function renderRecommendations() {
    if (!cart) return;
    const byId = new Map(cfg.products.map(p => [String(p.id), p]));
    const represented = cart.items.map(item => byId.get(String(item.product_id))).filter(Boolean);
    const fits = new Set(represented.map(p => p.fit));
    const colours = new Set(represented.map(p => colourKey(p.colour)));
    const ids = new Set();
    const candidates = cfg.products.filter(p => {
      if (ids.has(String(p.id)) || !fits.has(p.fit) || !colourKey(p.colour) ||
          colours.has(colourKey(p.colour)) || !p.variants.some(v => v.available)) return false;
      ids.add(String(p.id)); return true;
    });
    const seenColours = new Set(), varied = [], extraFits = [];
    candidates.forEach(p => {
      const key = colourKey(p.colour);
      if (seenColours.has(key)) extraFits.push(p); else { seenColours.add(key); varied.push(p); }
    });
    const products = [...varied, ...extraFits].slice(0, Math.min(10, cfg.recommendationLimit || 10));
    const selections = new Map([...host.querySelectorAll("[data-af-size]")].map(el => [el.dataset.afSize, el.value]));
    $("[data-af-recommendations]").hidden = !represented.length;
    $("[data-af-rec-caption]").textContent = products.length
      ? `${products.length} options · Same fit, new colours`
      : "No more colours available in your selected fits";
    $("[data-af-rec-list]").innerHTML = products.map(p => {
      const variant = p.variants.find(v => v.available && String(v.id) === selections.get(String(p.id))) || p.variants.find(v => v.available);
      return `<article class="af-rec" data-fit="${esc(p.fit)}" data-colour="${esc(colourKey(p.colour))}" data-product="${esc(p.id)}">
        <a href="${esc(p.url)}" tabindex="-1"><img src="${esc(p.image)}" alt="${esc(p.title)} in ${esc(p.colour)}" width="80" height="110" loading="lazy"></a>
        <div><h3><a href="${esc(p.url)}">${esc(p.title)}</a></h3><div class="af-rec-meta"><span>${esc(p.colour)}</span><strong data-af-rec-price>${money(variant.price)}</strong></div>
        <div class="af-rec-controls"><select data-af-size="${esc(p.id)}" aria-label="Size for ${esc(p.colour)} ${esc(p.title)}">${p.variants.map(v => `<option value="${v.id}" ${!v.available ? "disabled" : ""} ${v.id === variant.id ? "selected" : ""}>${esc(v.title)}${!v.available ? " · unavailable" : ""}</option>`).join("")}</select><button type="button" data-af-add="${esc(p.id)}" ${busy ? "disabled" : ""} aria-label="Add ${esc(p.colour)} ${esc(p.title)}">${esc(cfg.addLabel)}</button></div></div></article>`;
    }).join("");
  }
  // Existing Essentials BXGY pricing is deliberately retained. Predict only the
  // known three-tee states; never infer an upsell price through another discount.
  function nextPairIncrement(cart, products) {
    if (cart.currency !== "AUD" || cart.item_count !== 3 ||
        (cart.cart_level_discount_applications || []).length) return null;
    const eligibleIds = new Set(products.map(p => String(p.id)));
    if (!cart.items.length || cart.items.reduce((n, i) => n + i.quantity, 0) !== 3 ||
        !cart.items.every(i => eligibleIds.has(String(i.product_id)) &&
          i.original_price === 6900 && !i.selling_plan_allocation)) return null;
    const allocations = cart.items.flatMap(i => i.line_level_discount_allocations || [])
      .filter(a => a.amount > 0);
    if (!allocations.length || allocations.some(a =>
      a.discount_application?.title !== "ESSENTIAL_BUNDLE")) return null;
    const savings = cart.original_total_price - cart.total_price;
    if (cart.original_total_price !== 20700 ||
        ![3799, 3800].includes(savings) ||
        allocations.reduce((sum, a) => sum + a.amount, 0) !== savings) return null;
    return 6900 - savings;
  }
  // Display helper: when Shopify has applied ESSENTIAL_BUNDLE (A$38 off each
  // second tee), present complete pairs as $50 per tee and any odd tee at $69.
  // Returns null unless the cart's real discount total matches exactly, so the
  // drawer never shows prices Shopify will not honour at checkout.
  function pairDisplay(cart, products) {
    if (cart.currency !== "AUD") return null;
    const eligibleIds = new Set(products.map(p => String(p.id)));
    const lines = cart.items.filter(i => eligibleIds.has(String(i.product_id)) &&
      i.original_price === 6900 && !i.selling_plan_allocation);
    const units = lines.reduce((n, i) => n + i.quantity, 0);
    const pairs = Math.floor(units / 2);
    if (pairs < 1) return null;
    const allocations = lines.flatMap(i => i.line_level_discount_allocations || []).filter(a => a.amount > 0);
    if (!allocations.length || allocations.some(a => a.discount_application?.title !== "ESSENTIAL_BUNDLE")) return null;
    if (allocations.reduce((sum, a) => sum + a.amount, 0) !== pairs * 3800) return null;
    const otherLines = cart.items.filter(i => !lines.includes(i));
    if (otherLines.some(i => (i.line_level_discount_allocations || []).some(a => a.discount_application?.title === "ESSENTIAL_BUNDLE"))) return null;
    const map = new Map();
    let remaining = pairs * 2;
    lines.forEach(line => {
      const paired = Math.min(line.quantity, remaining);
      remaining -= paired;
      map.set(line.key, { paired, full: line.quantity - paired });
    });
    return map;
  }
  // Confetti: a short canvas burst from a milestone marker the first time the
  // cart crosses it (per page load). Skipped when the user prefers reduced motion.
  const celebrated = { shipping: null, deal: null };
  function confetti(fromEl) {
    if (cfg.confettiEnabled === false || !fromEl || !fromEl.isConnected) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const drawer = $(".af-drawer");
    if (!drawer || drawer.hidden) return;
    const canvas = document.createElement("canvas");
    canvas.className = "af-confetti";
    canvas.setAttribute("aria-hidden", "true");
    drawer.appendChild(canvas);
    const bounds = drawer.getBoundingClientRect(), mark = fromEl.getBoundingClientRect();
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    canvas.width = bounds.width * dpr; canvas.height = bounds.height * dpr;
    const ctx = canvas.getContext("2d"); ctx.scale(dpr, dpr);
    const ox = mark.left - bounds.left + mark.width / 2, oy = mark.top - bounds.top + mark.height / 2;
    const colours = ["#1a1a1a", "#c9a227", "#ffffff", "#2f7a4f", "#97ccf2", "#ee8787"];
    const pieces = Array.from({ length: 90 }, () => {
      const angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.2, speed = 6 + Math.random() * 7;
      return { x: ox, y: oy, vx: Math.cos(angle) * speed, vy: Math.sin(angle) * speed, w: 5 + Math.random() * 5, h: 3 + Math.random() * 4,
        rot: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.3, colour: colours[Math.floor(Math.random() * colours.length)], life: 1 };
    });
    const started = performance.now();
    function frame(now) {
      const t = (now - started) / 1000;
      ctx.clearRect(0, 0, bounds.width, bounds.height);
      let alive = 0;
      pieces.forEach(p => {
        p.vy += 0.28; p.vx *= 0.985; p.x += p.vx; p.y += p.vy; p.rot += p.vr;
        p.life = Math.max(0, 1 - Math.max(0, t - 1.1) / 0.6);
        if (p.life <= 0 || p.y > bounds.height + 20) return;
        alive++;
        ctx.save(); ctx.globalAlpha = p.life; ctx.translate(p.x, p.y); ctx.rotate(p.rot);
        ctx.fillStyle = p.colour; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h); ctx.restore();
      });
      if (alive && t < 2) requestAnimationFrame(frame); else canvas.remove();
    }
    requestAnimationFrame(frame);
  }
  function celebrate(key, reached, el) {
    if (celebrated[key] === null) { celebrated[key] = reached; return; } // first render: no burst for a pre-filled cart
    if (reached && !celebrated[key]) confetti(el);
    celebrated[key] = reached;
  }
  function render() {
    if (!cart) return;
    $("[data-af-count]").textContent = cart.item_count;
    $("[data-af-subtotal]").textContent = money(cart.total_price);
    $("[data-af-checkout-total]").textContent = money(cart.total_price);
    $(".af-checkout").disabled = busy || !cart.item_count;
    const savings = Math.max(0, cart.original_total_price - cart.total_price);
    $("[data-af-savings-row]").hidden = !savings;
    $("[data-af-savings]").textContent = money(savings);
    const discountLabels = (cart.cart_level_discount_applications || []).map(d => d.title);
    $("[data-af-discounts]").hidden = !discountLabels.length;
    $("[data-af-discounts]").textContent = discountLabels.join(" · ");
    const au = cart.currency === "AUD" && cfg.country === "AU";
    const shipping = Number(cfg.shippingCents), best = Number(cfg.bestCents);
    const validThresholds = shipping > 0 && best >= shipping;
    $("[data-af-rewards]").hidden = !au || !validThresholds;
    $("[data-af-offer]").hidden = !au;
    if (au && validThresholds) {
      const qualified = cart.total_price >= shipping, complete = cart.total_price >= best;
      $("[data-af-message]").innerHTML = complete ? `<strong>${esc(cfg.bestLabel)}</strong>`
        : qualified ? `<strong>${esc(cfg.shippingLabel)} unlocked!</strong> ${money(best - cart.total_price)} to ${esc(cfg.bestLabel)}`
        : `You're <strong>${money(shipping - cart.total_price)}</strong> away from ${esc(cfg.shippingLabel.toLowerCase())}!`;
      const percent = Math.min(100, cart.total_price / best * 100);
      $(".af-fill").style.width = `${percent}%`;
      $(".af-track").setAttribute("aria-valuenow", String(Math.round(percent)));
      $(".af-shipping").style.left = `${shipping / best * 100}%`;
      $(".af-shipping").classList.toggle("reached", qualified);
      $(".af-deal").classList.toggle("reached", complete);
      celebrate("shipping", qualified, $(".af-shipping .af-mark"));
      celebrate("deal", complete, $(".af-deal .af-mark"));
      $("[data-af-shipping-value]").textContent = money(shipping).replace(/\.00$/, "");
      $("[data-af-deal-value]").textContent = money(best).replace(/\.00$/, "");
      const nudge = $("[data-af-nudge]");
      const increment = cfg.pairNudgeEnabled ? nextPairIncrement(cart, cfg.products) : null;
      nudge.hidden = increment === null;
      nudge.textContent = increment === null ? "" :
        `Add one more Essential tee for just ${money(increment).replace(/\.00$/, "")} more.`;
    } else $("[data-af-nudge]").hidden = true;
    const byId = new Map(cfg.products.map(p => [String(p.id), p]));
    const pairs = pairDisplay(cart, cfg.products);
    $("[data-af-items]").innerHTML = cart.items.length ? cart.items.map(item => {
      const pair = pairs?.get(item.key);
      const priceHtml = pair && pair.paired > 0
        ? (pair.full === 0
          ? `<del>${money(item.original_price)}</del>${money(5000)}${item.quantity > 1 ? `<small>each · ${money(5000 * pair.paired)} total</small>` : ""}`
          : `<del>${money(item.original_price)}</del>${money(5000)}<small>${pair.paired} at ${money(5000)} + ${pair.full} at ${money(6900)} · ${money(5000 * pair.paired + 6900 * pair.full)} total</small>`)
        : `${item.original_price > item.final_price ? `<del>${money(item.original_price)}</del>` : ""}${money(item.final_price)}${item.quantity > 1 ? `<small>each · ${money(item.final_line_price)} total</small>` : ""}`;
      const discountNote = pair && pair.paired > 0 ? "Bundle price · 2 for $100" : null;
      const known = byId.get(String(item.product_id));
      const options = (item.options_with_values || []).map(o => o.value).filter(v => v !== "Default Title");
      const meta = [known?.colour, ...options].filter(Boolean).join(" / ");
      const discounts = (item.line_level_discount_allocations || []).map(a => a.discount_application?.title).filter(Boolean);
      const properties = Object.entries(item.properties || {}).filter(([k, v]) => !k.startsWith("_") && v).map(([k, v]) => `${k}: ${v}`).join(" · ");
      return `<article class="af-item" data-key="${esc(item.key)}"><a href="${esc(item.url)}" tabindex="-1">${item.image ? `<img src="${esc(item.image)}" alt="${esc(item.product_title)}" width="82" height="108">` : ""}</a>
      <div><div class="af-item-top"><h3><a href="${esc(item.url)}">${esc(item.product_title)}</a></h3><button type="button" class="af-remove" data-af-change="${esc(item.key)}" data-quantity="0" aria-label="Remove ${esc(item.product_title)} ${esc(meta)}" ${busy ? "disabled" : ""}>${icon("trash")}</button></div>
      <p class="af-meta">${esc(meta)}</p>${properties ? `<p class="af-meta">${esc(properties)}</p>` : ""}${item.selling_plan_allocation ? `<p class="af-meta">${esc(item.selling_plan_allocation.selling_plan.name)}</p>` : ""}
      <div class="af-item-bottom"><div class="af-stepper"><button type="button" data-af-change="${esc(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease ${esc(item.product_title)} ${esc(meta)}" ${busy ? "disabled" : ""}>−</button><output>${item.quantity}</output><button type="button" data-af-change="${esc(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase ${esc(item.product_title)} ${esc(meta)}" ${busy ? "disabled" : ""}>+</button></div>
      <div class="af-price">${priceHtml}</div></div>
      ${discountNote ? `<p class="af-line-discounts">${esc(discountNote)}</p>` : pairs ? "" : discounts.length ? `<p class="af-line-discounts">${esc([...new Set(discounts)].join(" · "))}</p>` : ""}</div></article>`;
    }).join("") : `<div class="af-empty"><p>${esc(cfg.emptyText)}</p><a class="af-shop" href="${esc(cfg.shopUrl || "/collections/all")}">${esc(cfg.shopLabel || "Shop now")}<span class="af-arrow" aria-hidden="true">→</span></a></div>`;
    $(".af-note").hidden = !cart.items.length;
    $("[data-af-offer]").hidden = $("[data-af-offer]").hidden || !cart.items.length;
    document.querySelectorAll("#cart-icon-bubble .cart-count-bubble").forEach(bubble => {
      bubble.hidden = !cart.item_count;
      const visible = bubble.querySelector('[aria-hidden="true"]');
      if (visible) visible.textContent = cart.item_count;
      const sr = bubble.querySelector(".visually-hidden");
      if (sr) sr.textContent = `${cart.item_count} items`;
    });
    renderRecommendations();
  }
  async function mutate(endpoint, payload, success) {
    if (busy) return;
    busy = true;
    ++refreshGeneration;
    error();
    host.querySelectorAll("[data-af-add],[data-af-change],.af-checkout").forEach(b => { b.disabled = true; });
    try {
      const response = await baseFetch(`${path}cart/${endpoint}.js`, { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(payload) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || "This cart change could not be completed.");
      if (endpoint === "add") {
        document.dispatchEvent(new CustomEvent("cart:add", { detail: { id: payload.id, qty: payload.quantity, data: result } }));
        try { window.Shopify?.analytics?.publish?.("af_cart_item_added", { variantId: String(payload.id), quantity: payload.quantity }); } catch (_) {}
      }
      announce(success);
    } catch (err) { error(err.message); productsUpdated = 0; refreshProducts(); }
    finally { busy = false; await refresh(); $(".af-checkout").disabled = !cart?.item_count; }
  }
  host.addEventListener("click", event => {
    if (event.target.closest("[data-af-close]")) { close(); return; }
    const add = event.target.closest("[data-af-add]");
    if (add) {
      const select = [...host.querySelectorAll("[data-af-size]")].find(s => s.dataset.afSize === add.dataset.afAdd);
      const product = cfg.products.find(p => String(p.id) === add.dataset.afAdd);
      const variant = product?.variants.find(v => String(v.id) === select?.value && v.available);
      if (variant) mutate("add", { id: variant.id, quantity: 1 }, `${product.title}, ${product.colour}, ${variant.title} added to cart.`);
      return;
    }
    const change = event.target.closest("[data-af-change]");
    if (change) mutate("change", { id: change.dataset.afChange, quantity: Number(change.dataset.quantity) }, "Cart updated.");
  });
  host.addEventListener("change", event => {
    const select = event.target.closest("[data-af-size]");
    if (!select) return;
    const p = cfg.products.find(p => String(p.id) === select.dataset.afSize);
    const v = p?.variants.find(v => String(v.id) === select.value);
    if (v) select.closest(".af-rec").querySelector("[data-af-rec-price]").textContent = money(v.price);
  });
  document.addEventListener("keydown", event => {
    if (!opened) return;
    if (event.key === "Escape") { event.preventDefault(); close(); return; }
    if (event.key === "Tab") {
      const focusable = [...drawer.querySelectorAll('button:not([disabled]),a[href],select:not([disabled]),[tabindex="0"]')].filter(el => el.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (!first) return;
      if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener("click", event => {
    const link = event.target.closest("#cart-icon-bubble, a[href='/cart'],a[href='" + path + "cart']");
    if (link && !host.contains(link) && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      event.preventDefault(); event.stopImmediatePropagation(); open();
    }
  }, true);
  // Observe successful native theme/app cart requests without changing their payload or response.
  window.fetch = function (...args) {
    const promise = baseFetch(...args);
    const raw = typeof args[0] === "string" || args[0] instanceof URL ? String(args[0]) : args[0]?.url;
    try {
      const url = new URL(raw, location.href);
      if (url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname)) {
        promise.then(response => { if (response.ok) scheduleRefresh(/\/add/.test(url.pathname)); }, () => {});
      }
    } catch (_) {}
    return promise;
  };
  const nativeDrawer = document.querySelector("cart-drawer");
  if (nativeDrawer) nativeDrawer.open = open;
  document.documentElement.classList.add("af-cart-ready");
  window.AlphaFortisCart = { open, close, refresh };
  window.addEventListener("pageshow", () => { if (opened) refresh(); });
  window.addEventListener("focus", () => { if (opened) { refresh(); refreshProducts(); } });
  document.addEventListener("visibilitychange", () => { if (!document.hidden && opened) { tick(); refresh(); } });
  document.addEventListener("shopify:section:load", event => {
    if (event.detail?.sectionId === "af-custom-cart") location.reload();
  });
  setInterval(tick, 1000);
  tick();
  // Theme Editor: only open while the cart section itself is selected, never on page load.
  document.addEventListener("shopify:section:select", event => { if (event.detail?.sectionId === "af-custom-cart") open(); });
  document.addEventListener("shopify:section:deselect", event => { if (event.detail?.sectionId === "af-custom-cart") close(); });
})();
